module.exports = __webpack_public_path__ + "static/media/29EUNOG7.738b62d3.jpg";